import React, {useState} from "react";
import {Avatar, Menu, MenuItem, Button, Modal, Typography, Box} from "@mui/material";
import {logoutAPI} from "../../apis/user_service";
import {NavLink} from "react-router-dom";


const UserMenu = ({userName}) => {
    //계정 드롭박스
    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);
    const menuClick = (event) => {setAnchorEl(event.currentTarget);};
    const menuClose = () => {setAnchorEl(null);};

    //로그아웃 모달
    const [modalOpen, setModalOpen] = useState(false);
    const modalClick = () => setModalOpen(true);
    const modalClose = () => setModalOpen(false);

    const logoutClick = () => {
        logoutAPI().then(res => {
            if (res.resultcode === '200') {
                // sessionStorage.clear();
                localStorage.clear();
                document.location.replace("/")
            }
        })
    };



    return (
        <>
            <Button id='login_btn' variant='outlined' onClick={menuClick}>내계정</Button>
            <Menu anchorEl={anchorEl} open={menuOpen} onClose={menuClick} onClick={menuClose}
                  PaperProps={{
                      elevation: 0,
                      sx: {minWidth:'240px',overflow: 'visible', filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))', marginTop: '0',
                          '& .MuiAvatar-root': {width: 32, height: 32, ml: -0.5, mr: 1,},
                          '& .MuiMenuItem-root:hover': {backgroundColor:'#fff'},
                      },
                  }}>
                <MenuItem onClick={menuClose}><Avatar/> {userName}</MenuItem>
                <MenuItem>
                    <span onClick={modalClick} className='logout_btn'>로그아웃</span>
                    <span className='setting_btn'>
                        {/*<NavLink to='/setting'>설정</NavLink>*/}
                        설정
                    </span>
                </MenuItem>
            </Menu>
            <Modal open={modalOpen} onClose={modalClose}>
                <Box  id="modal-container">
                    <Typography id="modal-modal-title" variant="h6" component="h4">로그아웃하시겠습니까?</Typography>
                    <Button variant='outlined' onClick={modalClose} sx={{border: '1px solid #d8d8d8', color:'#929292'}}>취소</Button>
                    <Button variant='contained' onClick={logoutClick} autoFocus>확인</Button>
                </Box>
            </Modal>
        </>

    );
};

export default UserMenu;
